/* eslint-disable react/require-default-props */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import { Row, Col } from 'reactstrap';
import {
  Typography,
  Button,
  Switch,
} from '@material-ui/core';
import Select from 'react-select';
import EditIcon from '@material-ui/icons/Edit';
import PropTypes from 'prop-types';
import MomentUtils from '@date-io/moment';
import {
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';

const ExamUpdate = ({
  data, closeModal, updateExam, semestersList,
}) => {
  const [durations, setDurations] = useState([
    { label: '30min', value: 30 },
    { label: '1h', value: 60 },
    { label: '1h30', value: 90 },
    { label: '2h', value: 120 },
  ]);
  const [semester, setSemester] = useState(1);
  const [catchUp, setCatchUp] = useState(false);
  const [modality, setModality] = useState({ value: '', label: '' });
  const [modalities, setModalities] = useState([]);
  const [examSubject, setExamSubject] = useState({});
  const [examBegin, setExamBegin] = useState(new Date());
  const [examEnd, setExamEnd] = useState(new Date());
  const [EWCorrect, setEWCorrect] = useState(false);
  const [duration, setDuration] = useState(durations[2]);
  const [deliveryDate, setDeliveryDate] = useState(new Date());
  const [minimumDeliveryDate, setMinimumDeliveryDate] = useState(new Date());

  const update = () => {
    const newData = {
      semester,
      catchUp,
      modality,
      examSubject,
      duration,
      examBegin: new Date(examBegin),
      examEnd: new Date(examEnd),
      deliveryDate: new Date(deliveryDate),
      EWCorrect,
    };
    updateExam(newData, data);
    closeModal();
  };

  const handleChange = (name) => (event) => {
    if (name === 'examBegin') setExamBegin(event);
    else if (name === 'examEnd') setExamEnd(event);
    else if (name === 'modality') setModality(event);
    else if (name === 'examSubject') setExamSubject(event);
    else if (name === 'duration') setDuration(event);
    else if (name === 'deliveryDate') setDeliveryDate(event);
  };

  useEffect(() => {
    if (modality.value === 'Sur la plateforme - Test de connaissance 60 minutes') {
      setDurations([{ label: '1h', value: 60 }]);
      setDuration({ label: '1h', value: 60 });
    } else if (modality.value === 'Sur la plateforme - Test de connaissance 90 minutes') {
      setDurations([{ label: '1h30', value: 90 }]);
      setDuration({ label: '1h30', value: 90 });
    } else {
      setDurations([
        { label: '30min', value: 30 },
        { label: '1h', value: 60 },
        { label: '1h30', value: 90 },
        { label: '2h', value: 120 },
      ]);
    }
  }, [modality]);

  useEffect(() => {
    semestersList.forEach((sem) => {
      if (sem.value === semester) {
        setModalities(sem.examModalities);
      }
    });
  }, [semester]);

  useEffect(() => {
    if (examBegin !== undefined) {
      const tmp = new Date(examEnd);
      const tmpEnd = new Date(examEnd);
      const tmpBegin = new Date(examBegin);
      tmp.setDate(tmp.getDate() + 21);
      setMinimumDeliveryDate(tmp);
      if (tmpBegin > tmpEnd) {
        tmpBegin.setHours(tmpBegin.getHours() + 1);
        if (new Date(deliveryDate) < new Date(tmp)) {
          setDeliveryDate(tmp);
        }
        setExamEnd(tmpBegin);
      } else if (new Date(deliveryDate) < new Date(tmp)) {
        setDeliveryDate(tmp);
      }
    }
  }, [examBegin, examEnd]);

  useEffect(() => {
    setSemester(data.semester);
    setExamBegin(data.examBegin);
    setExamEnd(data.examEnd);
    setCatchUp(data.catchUp);
    setModality({ label: data.modality, value: data.modality });
    setMinimumDeliveryDate(data.deliveryDate);
    setDeliveryDate(data.deliveryDate);
    setExamSubject(data.examSubject);
    setEWCorrect(data.EWCorrect);
    if (data.duration) {
      durations.forEach((durItem) => {
        if (durItem.value === data.duration) {
          setDuration(durItem);
        }
      });
    }
  }, [data]);

  return (
    <>
      <Row>
        <Col md={6}>
          <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
            Semestre
          </Typography>
          <Select
            value={semester}
            placeholder={semester}
            isDisabled
          />
        </Col>
        <Col
          md={6}
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-end',
            justifyContent: 'flex-start',
          }}
        >
          <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
            Rattrapage ?
          </Typography>
          <Switch
            checked={catchUp}
            onChange={() => setCatchUp(!catchUp)}
            color="primary"
          />
        </Col>
        <Col md={6}>
          <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
            Modalité d&apos;examen
          </Typography>
          <Select
            value={modality}
            placeholder={modality}
            options={modalities}
            onChange={handleChange('modality')}
          />
          {(modality !== undefined && (modality.value === 'Sur la plateforme - Test de placement'
          || modality.value === 'Sur la plateforme - Test de connaissance 60 minutes'
          || modality.value === 'Sur la plateforme - Test de connaissance 90 minutes'
          ))
            && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start',
                }}
              >
                <Typography
                  variant="caption"
                  style={{
                    color: '#F50057',
                    marginRight: '5px',
                  }}
                >
                  *
                </Typography>
                <Typography
                  variant="caption"
                  style={{ color: '#F50057' }}
                >
                  Les quiz sont automatiquement corrigés par notre plateforme
                </Typography>
              </div>
            )}
        </Col>
        {(modality !== undefined
            && modality.value !== 'Sur la plateforme - Dépôt de capsule vidéo'
            && modality.value !== 'Sur la plateforme - Dépôt de fichier'
            && !modality.value.includes('Oral')
            && !modality.value.includes('Sur table'))
          && (
            <Col
              md={6}
            >
              <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
                Durée de l&apos;examen
              </Typography>
              <Select
                value={duration}
                label="Duration"
                styles={{ width: '100%' }}
                options={durations}
                placeholder="Durée"
                onChange={handleChange('duration')}
              />
            </Col>
          )}
        <Col md={6}>
          <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
            Date et heure du début de l&apos;examen
          </Typography>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <KeyboardDateTimePicker
              required
              autoOk
              inputMode="none"
              fullWidth
              format="DD/MM - HH:mm"
              maxDate={examEnd}
              onChange={handleChange('examBegin')}
              value={examBegin}
              helperText="Date et heure de début de l'examen"
            />
          </MuiPickersUtilsProvider>
        </Col>
        <Col md={6}>
          <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
            Date et heure de fin de l&apos;examen
          </Typography>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <KeyboardDateTimePicker
              required
              autoOk
              inputMode="none"
              fullWidth
              //   error={errors.beginDate}
              format="DD/MM - HH:mm"
              onChange={handleChange('examEnd')}
              value={examEnd}
              helperText="Date et heure de fin de l'examen"
            />
          </MuiPickersUtilsProvider>
        </Col>
        {EWCorrect && (
          <Col md={6}>
            <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
              Date de rendu des notes de l&apos;examen
            </Typography>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <KeyboardDateTimePicker
                required
                minDate={minimumDeliveryDate}
                autoOk
                inputMode="none"
                fullWidth
                //   error={errors.beginDate}
                format="DD/MM/YYYY"
                onChange={handleChange('deliveryDate')}
                value={deliveryDate}
                helperText="Date de retour des notes"
              />
            </MuiPickersUtilsProvider>
          </Col>
        )}
        {modality
          && (modality.value !== 'Sur la plateforme - Test de placement'
            && modality.value !== 'Sur la plateforme - Test de connaissance 60 minutes'
            && modality.value !== 'Sur la plateforme - Test de connaissance 90 minutes'
          )
          && (
            <Col md={6}>
              <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
                Évaluation corrigée par EnglishWorld ?
              </Typography>
              <Switch
                checked={EWCorrect}
                onChange={() => setEWCorrect(!EWCorrect)}
                color="primary"
              />
            </Col>
          )}
        <Col md={6}>
          <Button
            onClick={() => update()}
            style={{ marginTop: '3.3em', padding: '1em 0 1em 0' }}
            variant="contained"
            color="primary"
            startIcon={<EditIcon>Update</EditIcon>}
            fullWidth
          >
            Mettre à jour
          </Button>
        </Col>
      </Row>
    </>
  );
};

ExamUpdate.propTypes = {
  data: PropTypes.object,
  closeModal: PropTypes.func.isRequired,
  updateExam: PropTypes.func.isRequired,
  semestersList: PropTypes.array.isRequired,
};

export default ExamUpdate;
